import { images } from "./Assets/images";
const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';

export const styleKeyFromCategory = (key) => {
    const normalizedKey = key?.toString().toLowerCase().replace(/\s/g, "_");
    switch (normalizedKey) {
        case "body":
            return "body";
        case "blood":
            return "blood";
        case "risks":
            return "risk";
        case "stress":
            return "stress";
        case "heart_health":
        case "heart":
            return "heart";
        case "resources":
            return "resources";
        case "wellness":
            return "wellness";
        default:
            return "body";
    }
};

export const convertUtcToLocal = (utcTimestamp) => {
    const timestampMs =
        utcTimestamp.toString().length === 10
            ? utcTimestamp * 1000
            : utcTimestamp;

    return new Date(timestampMs);
};

export const getHeartRateStatus = (heartRate, screenLabels) => {
    if (heartRate < 60) {
        return {
            status: "Low",
            comment: screenLabels?.low_heart_rate_desc?.label_value || "Low — typical in athletes or deep rest.",
        };
    } else if (heartRate >= 60 && heartRate <= 100) {
        return {
            status: "Normal",
            comment: screenLabels?.normal_heart_rate_desc?.label_value || "Within normal resting range.",
        };
    } else if (heartRate > 100) {
        return {
            status: "High",
            comment:
                screenLabels?.high_heart_rate_desc?.label_value || "High - could relate to stress or other factors.",
        };
    }

    return { status: "Normal", comment: "Heart rate assessment unavailable." };
};

export const calculateHeartRateFromRRI = (rriData) => {
    if (!Array.isArray(rriData) || rriData.length === 0) return null;

    const parsed = rriData.map((entry) => {
        let timestamp, interval;

        if (typeof entry === "object" && entry.interval) {
            timestamp = entry.timestamp;
            interval = entry.interval;
        } else if (typeof entry === "string") {
            const parts = entry.split(":");
            timestamp = parseFloat(parts[0]);
            interval = parseInt(parts[1].replace("ms", "").trim(), 10);
        }

        const heartRate = Math.round((60000 / interval) * 100) / 100;
        return { timestamp, interval, heartRate };
    });

    const avgHeartRate =
        Math.round(
            (parsed.reduce((sum, p) => sum + p.heartRate, 0) / parsed.length) * 100
        ) / 100;

    return { parsed, avgHeartRate };
};

// export const categoryStyles = {
//     wellness: { icon: images.wellnessIcon, color: "bg-blue" },
//     heart: { icon: images.heartIcon, color: "bg-pink" },
//     stress: { icon: images.stressIcon, color: "bg-green" },
//     blood: { icon: images.bloodIcon, color: "bg-yellow" },
//     body: { icon: images.bodyIcon, color: "bg-gray" },
//     risk: { icon: images.riskIcon, color: "bg-reddish-pink" },
//     resources: { icon: images.resourcesIcon, color: "bg-tan" },
//     default: { icon: images.wellnessIcon, color: "bg-default" },
// };

// export const categoryStyles = {
//     wellness: { icon: images.wellnessIcon, color: "bg-blue" },
//     heart: { icon: images.heartIcon, color: is4Life ? "bg-4life-heart" : "bg-pink" },
//     stress: { icon: images.stressIcon, color: is4Life ? "bg-4life-stress" : "bg-green" },
//     blood: { icon: images.bloodIcon, color: is4Life ? "bg-4life-blood" : "bg-yellow" },
//     body: { icon: images.bodyIcon, color: is4Life ? "bg-4life-body" : "bg-gray" },
//     risk: { icon: images.riskIcon, color: is4Life ? "bg-4life-risks" : "bg-reddish-pink" },
//     resources: { icon: images.resourcesIcon, color: "bg-tan" },
//     default: { icon: images.wellnessIcon, color: "bg-default" },
// };

export const categoryStyles = {
    wellness: { icon: images.wellnessIcon, color: "bg-blue", shadow: "shadow-wellness" },
    heart: { icon: images.heartIcon, color: is4Life ? "bg-4life-heart" : "bg-pink", shadow: "fourlife-shadow-heart" },
    stress: { icon: images.stressIcon, color: is4Life ? "bg-4life-stress" : "bg-green", shadow: "fourlife-shadow-stress" },
    blood: { icon: images.bloodIcon, color: is4Life ? "bg-4life-blood" : "bg-yellow", shadow: "fourlife-shadow-blood" },
    body: { icon: images.bodyIcon, color: is4Life ? "bg-4life-body" : "bg-gray", shadow: "fourlife-shadow-body" },
    risk: { icon: images.riskIcon, color: is4Life ? "bg-4life-risks" : "bg-reddish-pink", shadow: "fourlife-shadow-risk" },
    resources: { icon: images.resourcesIcon, color: "bg-tan" },
    default: { icon: images.wellnessIcon, color: "bg-default" },
};


export const getCategoryStyle = (key) => {
    const styleKey = styleKeyFromCategory(key);
    return (
        categoryStyles[styleKey] || {
            icon: images.wellnessIcon,
            color: "bg-default",
        }
    );
};

export const statusIconMap = {
    normal: images.normalIcon,
    Low: images.lowIcon,
    high: images.highIcon,
    "Very High": images.verihighIcon,
    "Very Low": images.lowIcon,
    Unknown: images.normalIcon,
    critical: images.criticalIcon,
    Mild: images.mildIcon,
};

export const filterOrder = [
    "heart_health",
    "blood",
    "stress",
    "body",
    "risks",
    "resources",
];

export const shortLabels = (screenLabels) => {
    return {
        body: screenLabels?.body_composition?.label_value || "Body Composition",
        blood: screenLabels?.blood_biomarkers?.label_value || "Blood Biomarkers",
        heart_health: screenLabels?.heart_health1?.label_value || "Heart Health",
        stress: screenLabels?.stress_metrics?.label_value || "Stress Metrics",
        risks: screenLabels?.risks?.label_value || "Risks",
    }
};

export const categoryHeaders = (screenLabels) => {
    return {
        heart_health: { name: screenLabels?.heart_health1?.label_value || "Heart Health", icon: images.heartIcon },
        blood: { name: screenLabels?.blood_biomarkers?.label_value || "Blood Biomarkers", icon: images.bloodIcon },
        stress: { name: screenLabels?.stress_metrics?.label_value || "Stress Metrics", icon: images.stressIcon },
        body: { name: screenLabels?.body_composition?.label_value || "Body Composition", icon: images.bodyIcon },
        risks: { name: screenLabels?.risks?.label_value || "Risks", icon: images.riskIcon },
    };
};
export const getWellnessMessage = (value, screenLabels) => {
    if (value >= 0 && value <= 3) {
        return (
            screenLabels?.wellness_low_msg?.label_value ||
            "Your wellness score is on the lower side, suggesting your body might be under stress. Prioritizing rest, healthy nutrition, and mindfulness can help improve your well-being."
        );
    } else if (value >= 4 && value <= 6) {
        return (
            screenLabels?.wellness_normal_msg?.label_value ||
            "Your wellness score is in the normal range. Keep maintaining your habits, and consider adding relaxing activities."
        );
    } else if (value >= 7 && value <= 10) {
        return (
            screenLabels?.wellness_good_msg?.label_value ||
            "You're building some great health habits, and it shows. Our analysis suggests you're on the right track! Keep maintaining activities that bring you joy and calm for continued balance."
        );
    } else {
        return screenLabels?.no_wellness_data?.label_value || "No wellness data available.";
    }
};

export const getWellnessLabel = (value, screenLabels) => {
    if (value >= 0 && value <= 3) {
        return screenLabels?.low?.label_value || "Low";
    } else if (value >= 4 && value <= 6) {
        return screenLabels?.normal?.label_value || "Normal";
    } else if (value >= 7 && value <= 10) {
        return screenLabels?.high?.label_value || "High";
    } else {
        return screenLabels?.unknown?.label_value || "Unknown";
    }
};